module.exports = __webpack_public_path__ + "static/kakmockup-1b41b5ba2a2597e82575d789d0a6d56f.png";